import { trackEvent } from "../src/lib/tracking";

document.addEventListener("DOMContentLoaded", () => {
  let clickCount = 0;
  let tooltipTimeout: NodeJS.Timeout | null = null;

  const openZendeskWidget = () => {
    if (window.zE) {
      window.zE("messenger", "open");
    }
  };

  const showTooltip = (tooltip: HTMLElement) => {
    tooltip.classList.remove("opacity-0", "invisible");
    tooltip.classList.add("opacity-100", "visible");

    if (tooltipTimeout) {
      clearTimeout(tooltipTimeout);
    }

    tooltipTimeout = setTimeout(() => {
      hideTooltip(tooltip);
    }, 4000);
  };

  const hideTooltip = (tooltip: HTMLElement) => {
    tooltip.classList.remove("opacity-100", "visible");
    tooltip.classList.add("opacity-0", "invisible");

    if (tooltipTimeout) {
      clearTimeout(tooltipTimeout);

      tooltipTimeout = null;
    }
  };

  const symptomChecker = document.querySelector(
    "[data-symptom-checker]"
  ) as HTMLElement;
  const tooltip = document.querySelector(
    "[data-symptom-tooltip]"
  ) as HTMLElement;

  if (symptomChecker && tooltip) {
    symptomChecker.addEventListener("click", (event) => {
      const eventName = "symptom_checker_CTA_click";

      event.preventDefault();

      clickCount++;

      if (clickCount > 1) {
        showTooltip(tooltip);
      }

      trackEvent(eventName);

      if (window.cioanalytics) {
        window.cioanalytics?.track(eventName, {
          path: window.location.pathname,
          referrer: window.location.origin,
          url: window.location.href,
          search: window.location.search,
        });
      }

      openZendeskWidget();
    });
  }
});
